// extracted by mini-css-extract-plugin
export default {"search-input":"styles_search-input__WznMq"};